import apis, { HasAccountAtMepResponse, CreateEmployeeResponse } from './services.api';

export interface YourData {
  name: string;
  emailAddress: string;
  countryCode: string;
  telephoneNumber: string;
  age: number;
  postCode: string;
  city: string;
  isChecked: boolean;
}

export interface EmployeeID {
  employeeId: number
}

export async function checkHasAccountAtMep(email: string): Promise<boolean> {
  const hasAccountResponse: HasAccountAtMepResponse = await apis.hasAccountAtMep(email);
  return hasAccountResponse.isExist;
}

export async function createEmployee(employeeData: YourData, campaignCode: string):
  Promise<CreateEmployeeResponse> {
  const createEmployeeResponse: CreateEmployeeResponse = await apis.createEmployee(
    employeeData.name, employeeData.emailAddress, employeeData.countryCode,
    employeeData.telephoneNumber, employeeData.age,
    employeeData.postCode, employeeData.city, campaignCode,
  );
  return createEmployeeResponse;
}
